<mfp-layout [headerBorder]="false" [showFooter]="false" [showHeader]="false">
  <div class="financial-health">
    <mfp-modal-header
      [title]="('FINANCIAL_HEALTH.HEADER.TITLE' | translate) + ' ' + lifePlan.user?.personal?.name"
      (closeClick)="close()"
    ></mfp-modal-header>

    <div class="financial-health__body">
      <div class="financial-health__tabs">
        <mfp-tabs [tabs]="tabs" [activeTab]="activeTab" (activeTabChange)="onActiveTabChange($event)"></mfp-tabs>
      </div>

      <ng-container *ngIf="activeTab === 0; else calculateTab">
        <div class="plans-tab">
          <div class="plans-tab__info">
            <mfp-alert alert="info">
              {{ 'FINANCIAL_HEALTH.INFO' | translate }}
            </mfp-alert>
          </div>

          <h1 class="plans-tab__title">{{ 'FINANCIAL_HEALTH.PLANS_TAB.TITLE' | translate }}</h1>

          <div class="plans-tab__plans">
            <div class="plans__options">
              <mfp-radio-button
                class="plans__options-base"
                idRadio="default"
                name="option"
                valueRadio="default"
                [label]="'FINANCIAL_HEALTH.PLANS_TAB.PLANS.BASE' | translate"
                [(ngModel)]="option"
              ></mfp-radio-button>
              <mfp-radio-button
                idRadio="improved"
                name="option"
                valueRadio="improved"
                [label]="'FINANCIAL_HEALTH.PLANS_TAB.PLANS.IMPROVED' | translate"
                [(ngModel)]="option"
              ></mfp-radio-button>
            </div>

            <mfp-circular-indicator
              class="plans__indicator"
              [basePercentage]="ratings.global.default"
              [currentPercentage]="option === 'improved' ? ratings.global.current : 0"
            ></mfp-circular-indicator>
          </div>

          <div class="plans-tab__subindicator">
            <ng-container *ngIf="option === 'default'; else improvedOption">
              <p class="plans-tab__subindicator-text">
                {{ ('FINANCIAL_HEALTH.PLANS_TAB.VALUE.BASE.0' | translate) + ' ' }}
              </p>
              <h2 class="plans-tab__subindicator-value">{{ ratings.global.default }}</h2>
              <p class="plans-tab__subindicator-text">
                {{ ' ' + ('FINANCIAL_HEALTH.PLANS_TAB.VALUE.BASE.1' | translate) + ' ' + 100 }}
              </p>
            </ng-container>

            <ng-template #improvedOption>
              <p class="plans-tab__subindicator-text">
                {{ 'FINANCIAL_HEALTH.PLANS_TAB.VALUE.IMPROVED.0' | translate }}
              </p>
              <h2 class="plans-tab__subindicator-value">
                {{
                  ('FINANCIAL_HEALTH.PLANS_TAB.VALUE.IMPROVED.1' | translate) +
                    ' ' +
                    (ratings.global.current - ratings.global.default) +
                    ' ' +
                    ('FINANCIAL_HEALTH.PLANS_TAB.VALUE.IMPROVED.2' | translate)
                }}
              </h2>
              <p class="plans-tab__subindicator-text">
                {{ ('FINANCIAL_HEALTH.PLANS_TAB.VALUE.IMPROVED.3' | translate) + ' ' + ratings.global.current }}
              </p>
              <p class="plans-tab__subindicator-text">
                {{ ' ' + ('FINANCIAL_HEALTH.PLANS_TAB.VALUE.IMPROVED.4' | translate) + ' ' + 100 }}
              </p>
            </ng-template>
          </div>

          <div class="plans-tab__protections">
            <ng-container *ngIf="lifePlan.type === 'COMPLETE' || lifePlan.type === 'DEATH'">
              <mfp-financial-health-feature
                [title]="'FINANCIAL_HEALTH.PLANS_TAB.PROTECTIONS.DEATH.TITLE' | translate"
                [description]="'FINANCIAL_HEALTH.PLANS_TAB.PROTECTIONS.DEATH.DESCRIPTION' | translate"
                [base]="ratings.protections.DEATH.default"
                [current]="option === 'improved' ? ratings.protections.DEATH.current : 0"
              >
                <div class="plans-tab__features">
                  <mfp-financial-health-feature-card
                    insurance="DEATH"
                    [title]="
                      ('FINANCIAL_HEALTH.PLANS_TAB.PROTECTIONS.PROTECTION_FOR' | translate) +
                      ' ' +
                      lifePlan.user?.personal?.name
                    "
                    [value]="
                      option === 'improved'
                        ? ratings.insuranceTargets[INSURANCE_DEATH_USER_ID].current
                        : ratings.insuranceTargets[INSURANCE_DEATH_USER_ID].default
                    "
                    [max]="
                      option === 'improved' ? ratings.protections.DEATH.current : ratings.protections.DEATH.default
                    "
                  ></mfp-financial-health-feature-card>

                  <ng-container *ngIf="hasSpouse">
                    <mfp-financial-health-feature-card
                      insurance="DEATH"
                      [title]="
                        ('FINANCIAL_HEALTH.PLANS_TAB.PROTECTIONS.PROTECTION_FOR' | translate) +
                        ' ' +
                        lifePlan.spouse?.personal?.name
                      "
                      [value]="
                        option === 'improved'
                          ? ratings.insuranceTargets[INSURANCE_DEATH_SPOUSE_ID].current
                          : ratings.insuranceTargets[INSURANCE_DEATH_SPOUSE_ID].default
                      "
                      [max]="
                        option === 'improved' ? ratings.protections.DEATH.current : ratings.protections.DEATH.default
                      "
                    ></mfp-financial-health-feature-card>
                  </ng-container>
                </div>
              </mfp-financial-health-feature>
            </ng-container>

            <ng-container *ngIf="lifePlan.type === 'COMPLETE' || lifePlan.type === 'EDUCATION'">
              <mfp-financial-health-feature
                [title]="'FINANCIAL_HEALTH.PLANS_TAB.PROTECTIONS.EDUCATION.TITLE' | translate"
                [description]="'FINANCIAL_HEALTH.PLANS_TAB.PROTECTIONS.EDUCATION.DESCRIPTION' | translate"
                [base]="ratings.protections.EDUCATION.default"
                [current]="option === 'improved' ? ratings.protections.EDUCATION.current : 0"
              >
                <div class="plans-tab__features">
                  <ng-container *ngFor="let child of lifePlan.user?.personal?.children; let index = index">
                    <mfp-financial-health-feature-card
                      insurance="EDUCATION"
                      [title]="child.name || ('FINANCIAL_HEALTH.PLANS_TAB.PROTECTIONS.CHILD' | translate) + ' ' + index"
                      [showIndicator]="true"
                      [base]="ratings.insuranceTargets[child.id] ? ratings.insuranceTargets[child.id].default : 0"
                      [current]="
                        option === 'improved'
                          ? ratings.insuranceTargets[child.id]
                            ? ratings.insuranceTargets[child.id].current
                            : 0
                          : 0
                      "
                      [value]="
                        option === 'improved'
                          ? ratings.insuranceTargets[child.id]
                            ? ratings.insuranceTargets[child.id].current
                            : 0
                          : ratings.insuranceTargets[child.id]?.default || 0
                      "
                      [max]="
                        option === 'improved'
                          ? ratings.protections.EDUCATION.current
                          : ratings.protections.EDUCATION.default
                      "
                    ></mfp-financial-health-feature-card>
                  </ng-container>
                </div>
              </mfp-financial-health-feature>
            </ng-container>

            <ng-container
              *ngIf="
                lifePlan.type === 'COMPLETE' ||
                (lifePlan.type === 'SAVING' &&
                  (lifePlan.insurances![SAVING_GENERAL] || savingInsuranceTargets.length > 0))
              "
            >
              <mfp-financial-health-feature
                [title]="'FINANCIAL_HEALTH.PLANS_TAB.PROTECTIONS.SAVING.TITLE' | translate"
                [description]="'FINANCIAL_HEALTH.PLANS_TAB.PROTECTIONS.SAVING.DESCRIPTION' | translate"
                [base]="ratings.protections.SAVING.default"
                [current]="option === 'improved' ? ratings.protections.SAVING.current : 0"
              >
                <div class="plans-tab__features">
                  <mfp-financial-health-feature-card
                    insurance="SAVING"
                    [title]="'FINANCIAL_HEALTH.PLANS_TAB.PROTECTIONS.SAVING_SECURITY' | translate"
                    [showIndicator]="true"
                    [base]="ratings.insuranceTargets[SAVING_GENERAL].default"
                    [current]="option === 'improved' ? ratings.insuranceTargets[SAVING_GENERAL].current : 0"
                    [value]="
                      option === 'improved'
                        ? ratings.insuranceTargets[SAVING_GENERAL]
                          ? ratings.insuranceTargets[SAVING_GENERAL].current
                          : 0
                        : ratings.insuranceTargets[SAVING_GENERAL]?.default || 0
                    "
                    [max]="
                      option === 'improved' ? ratings.protections.SAVING.current : ratings.protections.SAVING.default
                    "
                  ></mfp-financial-health-feature-card>
                  <ng-container *ngFor="let saving of savingInsuranceTargets">
                    <mfp-financial-health-feature-card
                      insurance="SAVING"
                      [title]="saving.name"
                      [showIndicator]="true"
                      [base]="ratings.insuranceTargets[saving.id].default"
                      [current]="
                        option === 'improved'
                          ? ratings.insuranceTargets[saving.id]
                            ? ratings.insuranceTargets[saving.id].current
                            : 0
                          : 0
                      "
                      [value]="
                        option === 'improved'
                          ? ratings.insuranceTargets[saving.id]
                            ? ratings.insuranceTargets[saving.id].current
                            : 0
                          : ratings.insuranceTargets[saving.id]?.default || 0
                      "
                      [max]="
                        option === 'improved' ? ratings.protections.SAVING.current : ratings.protections.SAVING.default
                      "
                    ></mfp-financial-health-feature-card>
                  </ng-container>
                </div>
              </mfp-financial-health-feature>
            </ng-container>
            <ng-container *ngIf="lifePlan.type === 'COMPLETE' || lifePlan.type === 'RETIREMENT'">
              <mfp-financial-health-feature
                [title]="'FINANCIAL_HEALTH.PLANS_TAB.PROTECTIONS.RETIREMENT.TITLE' | translate"
                [description]="'FINANCIAL_HEALTH.PLANS_TAB.PROTECTIONS.RETIREMENT.DESCRIPTION' | translate"
                [base]="ratings.protections.RETIREMENT.default"
                [current]="option === 'improved' ? ratings.protections.RETIREMENT.current : 0"
              >
                <div class="plans-tab__features">
                  <mfp-financial-health-feature-card
                    insurance="RETIREMENT"
                    [title]="
                      ('FINANCIAL_HEALTH.PLANS_TAB.PROTECTIONS.PROTECTION_FOR' | translate) +
                      ' ' +
                      lifePlan.user?.personal?.name
                    "
                    [value]="
                      option === 'improved'
                        ? ratings.insuranceTargets[INSURANCE_RETIREMENT_USER_ID].current
                        : ratings.insuranceTargets[INSURANCE_RETIREMENT_USER_ID].default
                    "
                    [max]="
                      option === 'improved'
                        ? ratings.protections.RETIREMENT.current
                        : ratings.protections.RETIREMENT.default
                    "
                  ></mfp-financial-health-feature-card>

                  <ng-container *ngIf="hasSpouse">
                    <mfp-financial-health-feature-card
                      insurance="RETIREMENT"
                      [title]="
                        ('FINANCIAL_HEALTH.PLANS_TAB.PROTECTIONS.PROTECTION_FOR' | translate) +
                        ' ' +
                        lifePlan.spouse?.personal?.name
                      "
                      [value]="
                        option === 'improved'
                          ? ratings.insuranceTargets[INSURANCE_RETIREMENT_SPOUSE_ID].current
                          : ratings.insuranceTargets[INSURANCE_RETIREMENT_SPOUSE_ID].default
                      "
                      [max]="
                        option === 'improved'
                          ? ratings.protections.RETIREMENT.current
                          : ratings.protections.RETIREMENT.default
                      "
                    ></mfp-financial-health-feature-card>
                  </ng-container>
                </div>
              </mfp-financial-health-feature>
            </ng-container>

            <ng-container *ngIf="lifePlan.type === 'COMPLETE' || lifePlan.type === 'SAVING'">
              <mfp-financial-health-feature
                [title]="'FINANCIAL_HEALTH.PLANS_TAB.PROTECTIONS.FINANCIAL_SITUATION.TITLE' | translate"
                [description]="'FINANCIAL_HEALTH.PLANS_TAB.PROTECTIONS.FINANCIAL_SITUATION.DESCRIPTION' | translate"
                [base]="ratings.financial.default"
                [current]="option === 'improved' ? ratings.financial.current : 0"
              >
                <div class="plans-tab__features">
                  <mfp-financial-health-feature-card
                    [title]="'FINANCIAL_HEALTH.PLANS_TAB.PROTECTIONS.FINANCIAL_SITUATION.SUBTITLE' | translate"
                    [value]="option === 'improved' ? ratings.financial.current : ratings.financial.default"
                    [max]="option === 'improved' ? ratings.financial.current : ratings.financial.default"
                  ></mfp-financial-health-feature-card>
                </div>
              </mfp-financial-health-feature>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <ng-template #calculateTab>
        <div class="calculate-tab">
          <h1 class="calculate-tab__title">{{ 'FINANCIAL_HEALTH.CALCULATE_TAB.TITLE' | translate }}</h1>
          <h2 class="calculate-tab__subtitle">{{ 'FINANCIAL_HEALTH.CALCULATE_TAB.SUBTITLE' | translate }}</h2>
          <p class="calculate-tab__description">{{ 'FINANCIAL_HEALTH.CALCULATE_TAB.DESCRIPTION' | translate }}</p>

          <div class="calculate-tab__chart">
            <mfp-financial-health-chart
              [financialSituationTitle]="'FINANCIAL_HEALTH.CALCULATE_TAB.FINANCIAL_SITUATION.TITLE' | translate"
              [deathTitle]="'FINANCIAL_HEALTH.CALCULATE_TAB.DEATH.TITLE' | translate"
              [educationTitle]="'FINANCIAL_HEALTH.CALCULATE_TAB.EDUCATION.TITLE' | translate"
              [savingTitle]="'FINANCIAL_HEALTH.CALCULATE_TAB.SAVING.TITLE' | translate"
              [retirementTitle]="'FINANCIAL_HEALTH.CALCULATE_TAB.RETIREMENT.TITLE' | translate"
            ></mfp-financial-health-chart>
          </div>

          <h2 class="calculate-tab__subtitle">{{ 'FINANCIAL_HEALTH.CALCULATE_TAB.CARD_SUBTITLE' | translate }}</h2>

          <div class="calculate-tab__protection-cards">
            <mfp-financial-health-protection-card
              insurance="DEATH"
              [title]="'FINANCIAL_HEALTH.CALCULATE_TAB.DEATH.TITLE' | translate"
              [value]="30"
              [description]="'FINANCIAL_HEALTH.CALCULATE_TAB.DEATH.DESCRIPTION' | translate"
            ></mfp-financial-health-protection-card>

            <mfp-financial-health-protection-card
              insurance="EDUCATION"
              [title]="'FINANCIAL_HEALTH.CALCULATE_TAB.EDUCATION.TITLE' | translate"
              [value]="10"
              [description]="'FINANCIAL_HEALTH.CALCULATE_TAB.EDUCATION.DESCRIPTION' | translate"
            ></mfp-financial-health-protection-card>

            <mfp-financial-health-protection-card
              insurance="SAVING"
              [title]="'FINANCIAL_HEALTH.CALCULATE_TAB.SAVING.TITLE' | translate"
              [value]="10"
              [description]="'FINANCIAL_HEALTH.CALCULATE_TAB.SAVING.DESCRIPTION' | translate"
            ></mfp-financial-health-protection-card>

            <mfp-financial-health-protection-card
              insurance="RETIREMENT"
              [title]="'FINANCIAL_HEALTH.CALCULATE_TAB.RETIREMENT.TITLE' | translate"
              [value]="30"
              [description]="'FINANCIAL_HEALTH.CALCULATE_TAB.RETIREMENT.DESCRIPTION' | translate"
            ></mfp-financial-health-protection-card>

            <mfp-financial-health-protection-card
              [title]="'FINANCIAL_HEALTH.CALCULATE_TAB.FINANCIAL_SITUATION.TITLE' | translate"
              [value]="20"
              [description]="'FINANCIAL_HEALTH.CALCULATE_TAB.FINANCIAL_SITUATION.DESCRIPTION' | translate"
            ></mfp-financial-health-protection-card>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</mfp-layout>
